import Rails from '@rails/ujs'
import './alpine'
import '../controllers/car'
import '../css/car.scss'

require.context('../assets/', true, /\.(svg|jpg|png)$/)
Rails.start()
